import React from 'react'

import Cultura from 'entity/Cultura'

import DefaultEntityCrud from 'components/form/DefaultEntityCrud'
import FormContent from 'components/form/FormContent'
import SelectInput from 'components/form/input/SelectInput'
import TextInput from 'components/form/input/TextInput'

function CulturaFormInter(props) {
    return (
        <FormContent sx={{ p: 2 }}>
            <TextInput sx={{ flex: 0.5 }} name="sequencialIndex" label="Código" disabled />
            <SelectInput
                sx={{ flex: 0.5 }}
                name="status"
                label="Status"
                options={["ATIVO", "INATIVO"]}
                required
            />
            <TextInput sx={{ flex: 2 }} name="cultura" label="Cultura" required />
        </FormContent>
    )
}

export default function CulturaForm() {
    return (
        <DefaultEntityCrud
            title={"Cadastro de Cultura"}
            EntityClass={Cultura}
            routeForm={"_cultura"}
            backRoute="consulta-cultura"

            formActions={{ novoForm: false, salvarForm: true, sairForm: true }}
        >
            {(props) => <CulturaFormInter {...props} />}
        </DefaultEntityCrud>
    )
}
